<template>
  <TabView
    :tabs="tabList"
  ></TabView>
</template>

<script setup>
import TabView from '@/components/TabView.vue'
import NftBookmarkTab from '@/components/NftTabs/NftBookmarkTab.vue';
import NftStoreTab from '@/components/NftTabs/NftStoreTab.vue';
import MyNftsTab from '@/components/NftTabs/MyNftsTab.vue';

const tabList = [
  { label: 'Store', component: NftStoreTab },
  { label: 'My Card', component: MyNftsTab },
  { label: 'Bookmard', component: NftBookmarkTab },
]
</script>